var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 36.666c9.205 0 16.667-7.462 16.667-16.666 0-9.205-7.462-16.667-16.666-16.667-9.205 0-16.667 7.462-16.667 16.667 0 9.204 7.462 16.666 16.667 16.666Z",
    fill: "#EF940F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.184 26.55c-.217 0-.434-.05-.634-.183l-5.166-3.084c-1.284-.766-2.234-2.45-2.234-3.933v-6.833c0-.684.567-1.25 1.25-1.25.684 0 1.25.566 1.25 1.25v6.833c0 .6.5 1.483 1.017 1.783l5.167 3.084c.6.35.783 1.116.433 1.716-.25.4-.667.617-1.083.617Z",
    fill: "#EF940F"
  })));
};
export default SvgClock;